import { faPenToSquare } from "@fortawesome/pro-solid-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mantine/core";

interface UnpublishedChangesIndicatorProps {
  /**
   * Whether to show a tooltip on hover. Set to false when the indicator
   * is accompanied by visible "Unpublished changes" text.
   */
  showTooltip?: boolean;
  /** Additional classes applied to the wrapper span. */
  className?: string;
}

export const UnpublishedChangesIndicator = ({
  showTooltip = true,
  className,
}: UnpublishedChangesIndicatorProps) => {
  const icon = (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-uw-yellow-0 px-1.5 py-1 ${className ?? ""}`}
    >
      <FontAwesomeIcon
        className="text-uw-yellow-8"
        icon={faPenToSquare}
        size="xs"
        aria-label="Unpublished changes"
      />
    </span>
  );

  if (!showTooltip) {
    return icon;
  }

  return (
    <Tooltip
      label="Unpublished changes"
      withArrow
      arrowSize={8}
      c="black"
      color="white"
      className="border border-uw-gray-2"
    >
      {icon}
    </Tooltip>
  );
};
